// extracted by mini-css-extract-plugin
export default {"contact":"Contact_contact__+aS9B","card":"Contact_card__8-qQM","card2":"Contact_card2__rXVfj","icons":"Contact_icons__i-Qk6","section":"Contact_section__Q4Gz6"};